// extracted by mini-css-extract-plugin
export var label = "_iz-2";
export var slideContainer = "_iz-0";
export var slider = "_iz-1";